// extracted by mini-css-extract-plugin
export default {"container":"Pages_container__6m3ua","top":"Pages_top__TOW7P","pageNumber":"Pages_pageNumber__Dhmrk"};